<template>
    <main id="mainCtrl">
        <header>
          <div>
            <button @click="createAccount" v-if="$can('admin.doctors.create')">
              <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAEnQAABJ0BfDRroQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAUoSURBVHic7ZrLb1ZFFMB/lzaANfUVHyCIGIEoKD4iG9+PSIuPlYGNiiW+3+nCGBIfcWGif4CGoDawcKE1RnChIVrUhSREjUjUTeOLQGxs64sW+Ur7uZivce6ZmXtn7p3bfobvl8zifvfMOTPnzpx77pkPWrRo0aJFixYt4rEHqFfUPp/BeRSiDRijOgeMNWxEY05MZcAKoCOyTp0OYHlMhbEdsDqyvsptxHbAKnG9FUhKttdybJQitgMuEdffRNApdUgbpWiPqQy4SFx/myFbF9eJQ07qkDaahpOAKdJR+9QMeRnhXZwm5KYatqIQcwusJP0UDwK/W+RcE3b9Pgoc0q4T4MKCYzSI6YAq9r9LV7Q4ENMBF4vrKh0gbRUmpgPk+3l/RN1S10zkG8GMkA5Wl+bI+wZBgMuE7HCpkVaEnNC8QPks5gfKe+N69xbB973eVPpjZ4L/O2JngjrRlmmVHPcr4Lh3QJVboCpqwA+zPQgbH5B+Td0RUfcq4ClUAtS0D+150g7YPrvDmXnWkHbAUWDJrI7Ig5jJSoL6aNELFv3Ahog2QG2BxSjnzm38VgN+Rn2CH4tsL4i7MFPW+yPo7QDuBnYAf1psTLc/gPeAO4ETItgNJkEdXuiDmgQeK6ivHXgS80PLpw03+s540FwB/GUZ0A5gWYCelcBXFj2h7QvggpJzCqYLFQTlYI4B7wDrgaVAp6P/bWQv9RFUjWCg0fajSmdZW+OWqDP0YB1wOGNQdeBRS78HUNtGyo4DrwI3YD8eawNuBLYARyz9J4H7oswsgKuwr4Q6sBdzImuBCYvsVmBRgN3FwBsWPTXgpmJTCaMTeA619FxP/zrRZzmqiqzLHEG9WYqyEXM1jALnl9CZy63AEO6J14Hdln47hcwEcHOGnfWiuehCxR5d9y7v2QSQAC9i37/Tr6VtwCbM5XyNRf6JHHtSPotei3xX/pT8aQP6LEb0lvU+/kTIfuZhM8QBYOYnAx59vEiANy0D8h3gMswjtSs97IY6QK6yKeA8j365PGMZzKDltwcd/eXy3OtpN9QBAF+KPo979nPShbnn9wELMAPPFPCQRce7Qm6zp+0iDpAPq79Mnnwi8Drpstog6l0+BNyLigvT9xNUIrOT9GGnPOiUb4isCO8j15+hu9Qh68ukvTmGmXNvwExsThEyMuWVNYS82BISe5aKe7bTay8WYiYYTztke0hvE5n9ya0iT5RiOkCeME14zdbCZqFo0DJwnR7+c8J8cU/+re4McT+mA84U9/4uEgMS1P7WeQmV87vY1jDYB5wM/KPdGyX917qFwG/atb6HdeSed8npnC2uRzz6GFyOuY98qy/3oGqHOh8LfRs9dRV5C2wSfXYVORi5Wlx/iIoHPmxHFTl09ojrmOV0idQtbXvxFmkvlv3Gvl7oG0flEXmErgBb4JYP04t9QskVRZRozEFVdHWdr3j0C3XAFiH/IwWr4geEIhm1i/Cw0FlDxZosQhywBjMf6S062HGhaG62uBftwPdC7y/AWRl93hbNxQLMh/YT1f6puxDrML8KvwbOKaHzXMwtOwl0lxpphbyAubR/Jbsy5KIbe2Xq2SgjrYgE8+twun2EuyI8TRuq6Dng0NGPCHyx/8gUg3moiN3juD8EvI9Kvw82fluEKqrejkp3bfQBj5CdsTYVvdhL5KFtgvz6YtOyGviU4pMfoIn/Xh9CN6qQUiN/0kdRJ8RrfRQ3YwzIohO4FnVwugQ4vfH7MCqb/A5VUT7sq/Bfqt29Nx04NQcAAAAASUVORK5CYII="
                  width="25" height="25"
              >
                <span>
                    Добавить врача
                </span>
            </button>

            <button @click="openMultiEditDialog" v-if="$can('admin.doctors.update')" :disabled="multiEditSelectedIds.length === 0">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHDSURBVHhe7dy/K0VhHMfxS6LkR8ogSTKaKINBWQz+ABZ28Rcwm/wL/gWzjBYjZguTsigpGwOfU8+p73HPo+c+3xt1zvtV7+XUs3zq3nNdjg4AAACAfCvqyNGaarVD9eXoWLUaAzrZAV/UeULPigEDO+B1cSHBhWLAgAGdYgMOqkXTkCrFBhxT9kwTm1UVsQEnVXm9aF6VYgPuKnumiXW9ShmwtxjQWfKAA2rKVLwnlmIDDit7pomNq4rYgL+JDdhKDOhkB3xXtwm9KQYM7IA5MaCqGya11g+4pPYdLSsAAJBjTm06WlCtxudAJwZ0sgN+qteEPhQDBnZAvo3JwIBODOjUzwG3Vd17ZpO6VBX9HJBfKhUXEjCg0c8BZ1TdTytNalVVcBNxYkAnO+CTOk3oQTFgYAfMiQFV3TCptX7ADXXmaEsBAAD8Az4HOjGgEwM62QFvVN3TOT+7UgwY2AH5OisDAzrFBhxV9hnhaVWKDbiu7JkmdqIqYgPyqFd9Xa9SBuyt5AFHlP3vHBOqFBuw+It/e6aJ7akKbiJODOhkB7xXOwndKQYM7IA5MaCqGya11g9Y3FUeHR0oAAAAAMAf6HS+AWpqFD4ChQwgAAAAAElFTkSuQmCC" width="25" height="25">
              <template v-if="multiEditSelectedIds.length > 0">
                {{multiEditSelectedIds.length}}
              </template>
            </button>
          </div>

        </header>

        <DoctorEdit ref="doctorEditDialog"/>
        <DoctorMulti ref="doctorMultiDialog"/>
        <dialog-doctor-moderation ref="doctorModerate" @updated="onUpdatedEvent"/>

        <v-table id="table"
                 request-uri="doctors/getList"
                 pagination-uri="doctors/tableMeta"
                 pagesize="50"
                 :lazycount="true"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th width="25"> </v-th>
                    <v-th name="city" width="45">
                        Город
                    </v-th>
                    <v-th name="img" width="55">
                        Фото
                    </v-th>
                    <v-th name="fio" sort="nameFamily, nameFirst, nameFathers" minwidth="200">
                        Фамилия Имя Отчество
                    </v-th>
                    <v-th name="rating" sort="rating" width="50" tooltip="Рейтинг">
                        <i class="fas fa-star-half-alt"></i>
                    </v-th>
                    <v-th name="moderationNeeded" width="30" v-tooltip="{content: 'Требуется модерация'}">
                        М
                    </v-th>
                    <v-th name="clinicName" minwidth="150">
                        Клиника
                    </v-th>
                    <v-th v-if="!isClinicNameHidden()" name="clinicNameExact" width="10" />
                    <v-th name="price" width="50" tooltip="Стоимость консультации">
                        Прием
                    </v-th>
                    <v-th name="info" sort="info" width="50" tooltip="Описание">
                        Опис
                    </v-th>
                    <v-th name="degree" width="40" tooltip="Степень">
                      Степ
                    </v-th>
                    <v-th name="category" width="35" tooltip="Категория">
                      Кат
                    </v-th>
                    <v-th name="rank" width="35" tooltip="Звание">
                      Зв
                    </v-th>
                    <v-th name="experience" width="35" tooltip="Стаж">
                        Ст
                    </v-th>
                    <v-th name="sex" width="30">
                      Пол
                    </v-th>
                    <v-th name="speciality" sort="specialities_ids" minwidth="150">
                        Специализации
                    </v-th>
                    <v-th name="url" sort="url" width="120">
                        URL
                    </v-th>
                    <v-th name="link_created_at" sort="created_at" width="67">
                        Создан
                    </v-th>
                    <v-th name="createdBy_id" sort="createdBy_id" width="40" tooltip="Создатель">
                        Созд
                    </v-th>
                    <v-th name="locality" width="90">
                        Нас. пункт
                    </v-th>
                  <v-th name="link_deleted_at"  width="67">
                    Удален
                  </v-th>
                </v-tr>
                <v-tr>
                    <v-th>
                        <input type="checkbox" :value="true" @click.stop.prevent="multiEditLinksAll" v-show="multiEditSelectedOnPageStatus === 'none'">
                        <input type="checkbox" :value="true" @click.stop.prevent="multiEditLinksNone" v-if="multiEditSelectedOnPageStatus === 'part'" indeterminated>
                        <input type="checkbox" :value="true" @click.stop.prevent="multiEditLinksNone" v-show="multiEditSelectedOnPageStatus === 'all'" checked>
                    </v-th>
                    <v-th name="city" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...cityOptions
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="img" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'Есть', value: 'ANY' },
                                  { text: 'Нет', value: 'MISSING'},
                                ]">

                        </v-select>
                    </v-th>
                    <v-th name="fio" :debounce="true" v-slot="{filter}" highlight="*">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="rating" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "-",
                                    text: "- нет"
                                },
                                {
                                    value: "1",
                                    text: "1 ★☆☆☆☆"
                                },
                                {
                                    value: "2",
                                    text: "2 ★★☆☆☆"
                                },
                                {
                                    value: "3",
                                    text: "3 ★★★☆☆"
                                },
                                {
                                    value: "4",
                                    text: "4 ★★★★☆"
                                },
                                {
                                    value: "5",
                                    text: "5 ★★★★★"
                                }
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="moderationNeeded" v-slot="{filter}">
                        <v-select v-model="filter.value"
                                  :options='[
                                  { text: "\u00a0", value: "" },
                                  { text: "⊞ Новый", value: "NEW" },
                                  { text: "👁 Измененные", value: "CHANGED"},
                                  { text: "👁 На модерации (новые и измененные)", value: "MOD_NEEDED"},
                                  { text: "✔ Не требуется модерацию", value: "MOD_NOT_NEEDED"},
                                ]'>
                            <template v-slot:option="option">
                                <div v-html="option.text"/>
                            </template>
                        </v-select>
                    </v-th>
                    <v-th name="clinicName" :debounce="true" style="padding-right: 25px" v-slot="{filter}">
                       <v-input type="search" v-model="filter.value" style="flex: 1 1 0; min-width: auto !important;"/>
                    </v-th>
                    <v-th-s v-if="!isClinicNameHidden()" name="clinicNameExact"  v-slot="{filter}" >
                        <input v-tooltip="{content: 'Точное совпадение'}" type="checkbox" style="margin-left: -27px;" v-model="filter.value"/>
                    </v-th-s>
                    <v-th name="price" v-slot="{filter}" >
                        <v-select v-model="filter.value"
                                  :options="[
                                  { text: '\u00a0', value: '' },
                                  { text: 'платно', value: '>0' },
                                  { text: 'бесплатно', value: '=0'},
                                  { text: 'неизвестно', value: '=?'},
                                ]"/>
                    </v-th>
                    <v-th name="info" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                  { value: "", text: "\u00a0" },
                                  { value: "ANY", text: "Есть" },
                                  { value: "MISSING", text: "Нет" }
                              ]'
                        />
                    </v-th>
                    <v-th name="degree" v-slot="{filter}">
                      <v-select
                          v-model="filter.value"
                          :options='[
                                  { value: "", text: "\u00a0" },
                                  { value: "MISSING", text: "[пусто]" },
                                  { value: "ANY", text: "[любое]" },
                                  { value: "NONE", text: "Нет" },
                                  { value: "KMN", text: "КМН" },
                                  { value: "DMN", text: "ДМН" },
                              ]'
                      />
                    </v-th>
                    <v-th name="category" v-slot="{filter}">
                      <v-select
                          v-model="filter.value"
                          :options='[
                                  { value: "", text: "\u00a0" },
                                  { value: "ANY", text: "Есть" },
                                  { value: "MISSING", text: "Нет" },
                                  { value: "NONE", text: "-" },
                                  { value: "FIRST", text: "I" },
                                  { value: "SECOND", text: "II" },
                                  { value: "TOP", text: "B" },
                              ]'
                      />
                    </v-th>
                    <v-th name="rank" v-slot="{filter}">
                      <v-select
                          v-model="filter.value"
                          :options='[
                                  { value: "", text: "\u00a0" },
                                  { value: "ANY", text: "Есть" },
                                  { value: "MISSING", text: "Нет" },
                                  { value: "NONE", text: "-" },
                                  { value: "PROFESSOR", text: "П" },
                                  { value: "DOCENT", text: "Д" },
                              ]'
                      />
                    </v-th>
                    <v-th name="experience" v-slot="{filter}">
                        <v-input type="search" v-model="filter.value"/>
                    </v-th>
                    <v-th name="sex" v-slot="{filter}">
                    <v-select
                        v-model="filter.value"
                        :options='[
                                { value: "", text: "\u00a0" },
                                { value: "ANY", text: "Есть" },
                                { value: "MISSING", text: "Нет" },
                                { value: "MALE", text: "М" },
                                { value: "FEMALE", text: "Ж" }
                            ]'
                    />
                  </v-th>
                    <v-th name="speciality" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...specialityOptions
                            ]'
                        />
                    </v-th>
                    <v-th name="url" v-slot="{filter}">
                        <v-input type="search" v-model="filter.value"/>
                    </v-th>
                    <v-th name="link_created_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="createdBy_id" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                {
                                    value: "-",
                                    text: "— не задано —"
                                },
                                ...managerOptions.map(item => {
                                    return {
                                        value: item.id,
                                        text: item.fioInitials + " - " + item.fio
                                    };
                                })
                            ]'
                        />
                    </v-th>
                    <v-th name="locality" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...localityOptions
                            ]'
                        />
                    </v-th>

                    <v-th name="link_deleted_at" v-slot="{filter}">
                      <date-piker v-model="filter.value"/>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index, indexOnPage }">
                <v-tr :class="{warning: !item.approved}" class="hover pointer" @click="(row, event) => handleRowClick(event, row, item)">
                    <v-td @click.stop.prevent align="center">
                        <div v-for="r in item.clinics">
                            <input type="checkbox" v-model="multiEditSelectedIds" @click.shift="selectGroup(r.link_id, indexOnPage)" :value="r.link_id" @click.stop>
                        </div>
                    </v-td>
                    <v-td name="city" :highlight="cityHighlight" align="center">
                        <div v-for="clinic in item.clinics" :class="{warning: clinic.isModerationSource}">
                            <div v-tooltip="{content: clinic.cityObj.name}"
                                 :style="{'text-decoration' : (clinic.link_deleted_at === null ? 'inherit' : 'line-through')}"
                            >
                                {{ clinic.cityObj.nameShort }}
                            </div>
                        </div>
                      <div v-for="source in item.otherModSources" :class="{warning: source.moderationNeeded}">
                        &mdash;
                      </div>
                    </v-td>
                    <v-td name="img" width="55">
                        <img v-if="item.imgInfo.little" width="40" :src="item.imgInfo.little" alt="">
                    </v-td>
                    <v-td name="fio">
                        <div class="text-ellipsis-hover">
                            <b>{{item.nameFamily}}</b> {{item.nameFirst}} {{item.nameFathers}}
                        </div>
                    </v-td>
                    <v-td name="rating" highlight="*" align="center" width="50">
                        <span v-if="item.rating == null" v-tooltip="'Внутренний: '+ item.ratingInternal">&mdash;</span>

                        <template v-else>
                            <span v-tooltip="{content:innerTooltip(item)}">
                                {{ (Math.round(item.rating * 5 * 10) / 10).toFixed(1) }}
                            </span>
                        </template>
                    </v-td>
                    <v-td name="moderationNeeded" align="center">
                        <div v-for="clinic in item.clinics">
                            <div v-if="clinic.isModerationSource" class="warning">
                              <i v-if="item.approved" class="fa fa-eye"></i>
                              <i v-else class="far fa-plus-square"></i>
                            </div>
                            <div v-else><i class="far fa-check"></i></div>
                        </div>
                      <div v-for="source in item.otherModSources" :class="{warning: source.moderationNeeded}">
                        <i v-if="item.approved" class="fa fa-eye"></i>
                        <i v-else class="far fa-plus-square"></i>
                      </div>
                    </v-td>
                    <v-td name="clinicName">
                        <div v-for="clinic in item.clinics">
                            <div class="text-ellipsis" :class="{warning: clinic.isModerationSource}"
                                 :style="{'text-decoration' : (clinic.link_deleted_at === null ? 'inherit' : 'line-through')}">
                                <i class="fa fa-book"
                                   :class="[clinic.hasAbonSubscription ? 'text-success' : 'text-danger']"
                                   v-tooltip="{content: clinic.hasAbonSubscription ? 'Есть запись' : 'Нет записи'}"></i>
                                {{clinic.name}}
                            </div>
                        </div>
                      <div v-for="source in item.otherModSources" :class="{warning: source.moderationNeeded}">
                        <div class="text-ellipsis">
                          {{source.name}}
                        </div>
                      </div>
                    </v-td>
                    <v-td v-if="!isClinicNameHidden()" name="clinicNameExact" />
                    <v-td name="price" align="right">
                        <div v-for="clinic in item.clinics">
                            <div :class="{warning: clinic.isModerationSource}">
                                <template v-if="clinic.price === '' || clinic.price === null">&mdash;</template>
                                <template v-if="clinic.price === 0">беспл.</template>
                                <template v-if="clinic.price > 0">{{clinic.price}}</template>
                            </div>
                        </div>
                      <div v-for="source in item.otherModSources" :class="{warning: source.moderationNeeded}">
                        &mdash;
                      </div>
                    </v-td>
                    <v-td name="info" align="center">
                        <template v-if="item.info">
                            есть
                        </template>
                        <template v-else>
                            нет
                        </template>
                    </v-td>
                    <v-td name="degree" highlight="*" align="center">
                      <template v-if="item.degree === 'NONE'">
                        нет
                      </template>
                      <template v-if="item.degree === 'KMN'">
                        КМН
                      </template>
                      <template v-if="item.degree === 'DMN'">
                        ДМН
                      </template>
                    </v-td>
                    <v-td name="category" highlight="*" align="center">
                      <template v-if="item.category === 'NONE'">
                        -
                      </template>
                      <template v-if="item.category === ''">
                        нет
                      </template>
                      <template v-if="item.category === 'FIRST'">
                        I
                      </template>
                      <template v-if="item.category === 'SECOND'">
                        II
                      </template>
                      <template v-if="item.category === 'TOP'">
                        B
                      </template>
                    </v-td>
                    <v-td name="rank" highlight="*" align="center">
                      <template v-if="item.rank === 'NONE'">
                        -
                      </template>
                      <template v-if="item.rank === ''">
                        нет
                      </template>
                      <template v-if="item.rank === 'PROFESSOR'">
                        П
                      </template>
                      <template v-if="item.rank === 'DOCENT'">
                        Д
                      </template>
                    </v-td>
                    <v-td name="experience" align="center">{{item.experience}}</v-td>
                    <v-td name="sex" highlight="*" align="center">
                    <template v-if="item.sex === ''">
                      нет
                    </template>
                    <template v-if="item.sex === 'MALE'">
                      М
                    </template>
                    <template v-if="item.sex === 'FEMALE'">
                      Ж
                    </template>
                  </v-td>
                    <v-td name="speciality" :highlight="specHighlight">{{item.specialitiesAsText}}</v-td>
                    <v-td name="url">
                        <a class="text-ellipsis"
                           :href="$parent.frontendUrl+'/'+item.bestCityCharId+'/doctor/'+item.url"
                           v-tooltip="{content: $parent.frontendUrl+'<br/>/'+item.bestCityCharId+'/doctor/'+item.url}"
                           target='_blank'
                           @click.stop.prevent="openHref($parent.frontendUrl+'/'+item.bestCityCharId+'/doctor/'+item.url)">
                            /{{item.url}}
                        </a>
                    </v-td>
                    <v-td :highlight="createdAtHighlight" name="link_created_at" align="center">
                        <div v-for="clinic in item.clinics">
                          <span v-if="clinic.link_created_at" :style="{'text-decoration' : (clinic.link_deleted_at === null ? 'inherit' : 'line-through')}">
                            {{clinic.link_created_at | formatDateWithShortYearAndMonth}}
                          </span>
                          <span v-else>&mdash;</span>
                        </div>
                      <div v-for="source in item.otherModSources" :class="{warning: source.moderationNeeded}">
                        &mdash;
                      </div>
                    </v-td>
                    <v-td name="createdBy_id" align="center">
                        <div v-for="clinic in item.clinics">
                            <span v-if="clinic.link_createdBy" :style="{'text-decoration' : (clinic.link_deleted_at === null ? 'inherit' : 'line-through')}"
                                  v-tooltip="{content: clinic.link_createdBy.fio}"
                            >{{clinic.link_createdBy.fioInitials}}</span>
                            <span v-else>&mdash;</span>
                        </div>
                      <div v-for="source in item.otherModSources" :class="{warning: source.moderationNeeded}">
                        &mdash;
                      </div>
                    </v-td>
                    <v-td name="locality" :highlight="localityHighlight" align="center">
                        <div v-for="clinic in item.clinics">
                            <div v-if="clinic.localityObj.name"  v-tooltip="{content: clinic.localityObj.name}" :style="{'text-decoration' : (clinic.link_deleted_at === null ? 'inherit' : 'line-through')}">
                                {{clinic.localityObj.name}}
                            </div>
                            <div v-else>
                                &mdash;
                            </div>
                        </div>
                      <div v-for="source in item.otherModSources" :class="{warning: source.moderationNeeded}">
                        &mdash;
                      </div>
                    </v-td>
                    <v-td name="link_deleted_at" :highlight="deletedAtHighlight">
                      <div v-for="clinic in item.clinics">
                        <span v-if="clinic.link_deleted_at">{{ clinic.link_deleted_at | formatDateWithShortYearAndMonth }}</span>
                        <span v-else>&mdash;</span>
                      </div>
                      <div v-for="source in item.otherModSources" :class="{warning: source.moderationNeeded}">
                        &mdash;
                      </div>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import DoctorEdit from "@dialogs/common/doctors/DoctorEditDialog";
import DialogDoctorModeration from '@dialogs/admin/doctorModeration/Dialog'
import DoctorMulti from "@dialogs/common/doctors/DoctorMultiEditDialog";
import moment from 'moment';
import 'moment/locale/ru';
import _ from "lodash";

    export default {
        components: {
            DoctorEdit,
            DoctorMulti,
            DialogDoctorModeration
        },

        props: {
            cityOptions: {
                type: Array,
                required: true
            },
            specialityOptions: {
                type: Array,
                required: true
            },
            managerOptions: {
                type: Array,
                required: true
            },
            localityOptions: {
                type: Array,
                required: true
            },
        },
        data: function () {
            return {
                multiEditSelectedIds: []
            };
        },
        mounted: function () {
            this.$refs.table.update();
        },

      methods: {

        openMultiEditDialog () {
          this.$refs.doctorMultiDialog.show(this.multiEditSelectedIds);
        },
        selectGroup(id, rowId) {
          let ids = [];
          let firstChecked = this.firstPageMultiSelectIndex;
          let lastChecked = this.lastPageMultiSelectIndex;
          console.log('firstChecked',firstChecked)
          if (rowId < firstChecked){
            this.$refs.table.rows.map((item, index) => {
              if (index >= rowId && index <= firstChecked){
                let flag = item.clinics.filter((placeOfWork) => placeOfWork.link_id === id).length === 0
                item.clinics.map((r) => {
                  if (r.link_id === id){
                    flag = true
                  }
                  if (flag){
                    this.multiEditSelectedIds.push(r.link_id);
                  }
                });
              }
            });
          }else if(rowId > lastChecked){
            this.$refs.table.rows.map((item, index) => {
              if (index >= lastChecked && index <= rowId){
                item.clinics.every((r) => {
                  this.multiEditSelectedIds.push(r.link_id);
                  return r.link_id !== id;
                });
              }
            });
          }

          this.multiEditSelectedIds = _.uniq(this.multiEditSelectedIds);
        },
        multiEditLinksNone() {
          this.multiEditSelectedIds = [];
        },
        multiEditLinksAll() {
          this.$refs.table.rows.map((item) => {
            item.clinics.map((r) => {
              this.multiEditSelectedIds.  push(r.link_id);
            });
          });
          this.multiEditSelectedIds = _.uniq(this.multiEditSelectedIds);
        },
        handleRowClick: function (event, row, item) {
          row.startLoadingAnimation();

          if (item.moderationNeeded) {
            return this.moderate(item.id, row);
          }

          return this.readAccount(item.id, event, row);
        },

        onUpdatedEvent() {
          this.$refs.table.update();
        },

        createAccount: function () {
          this.$refs.doctorEditDialog.create();
        },

        readAccount: function (id, e, row) {
          this.$refs.doctorEditDialog
              .read(id)
              .then(() => row.stopLoadingAnimation())
              .catch(() => row.stopLoadingAnimation());
        },

        innerTooltip(item) {
          return `<div class="tooltip-content">
                            <table>
                                <tr><td width="85">Рейтинг:</td><td width="50">` + (Math.round(item.rating * 5 * 10) / 10).toFixed(1) + `</td></tr>
                                <tr><td>Отзывы:</td><td>` + item.ratingCommentCount + `</td></tr>
                                <tr><td>Внутренний:</td><td>` + item.ratingInternal + `</td></tr>
                            </table>
                        </div>`;
        },
        moderate: function (id, row)  {
          this.$refs.doctorModerate
              .showModal(id)
              .then(() => row.stopLoadingAnimation())
              .catch(() => row.stopLoadingAnimation());

        },

        openHref(href) {
          window.open(href)
        },

        isClinicNameHidden() {
          return this.$refs.table ? this.$refs.table.hidden.indexOf('clinicName') !== -1 : false;
        },
      },

        computed: {
            // striptagsTrimNoHttp () {
            //     return "striptags trim nohttp";
            // },
          cityHighlight(item) {
            if (!this.$refs || !this.$refs.table.filter) {
              return '*';
            }
            if(this.$refs.table.filter.city && this.cityOptions.length){
              return this.cityOptions.find(city => {return city.value === this.$refs.table.filter.city}).textAbbr
            }
            return '*';
          },
          localityHighlight(item) {
            if (!this.$refs || !this.$refs.table.filter) {
              return '*';
            }
            if(this.$refs.table.filter.locality && this.localityOptions.length){
              return this.localityOptions.find(city => {return city.value === this.$refs.table.filter.locality}).text
            }
            return '*';
          },
          specHighlight(item) {
            if (!this.$refs || !this.$refs.table.filter) {
              return '*';
            }
            if(this.$refs.table.filter.speciality && this.specialityOptions.length){
              return this.specialityOptions.find(sp => {return sp.value === this.$refs.table.filter.speciality}).text
            }
            return '*';
          },
          createdAtHighlight() {
            if (!this.$refs || !this.$refs.table.filter) {
              return '*';
            }
            if(this.$refs.table.filter.link_created_at){
              return moment(this.$refs.table.filter.link_created_at, "DD.MM.YYYY").locale('ru')
                  .format('DD MMM YYYY')
                  .replace(/(\d{2}) (\W{3})(\W{0,2}).\s(\d{4})/g, "$1 $2 $4" )
            }
            return '*';
          },
          deletedAtHighlight() {
            if (!this.$refs || !this.$refs.table.filter) {
              return '*';
            }
            if(this.$refs.table.filter.link_deleted_at){
              return moment(this.$refs.table.filter.link_deleted_at, "DD.MM.YYYY").locale('ru')
                  .format('DD MMM YYYY')
                  .replace(/(\d{2}) (\W{3})(\W{0,2}).\s(\d{4})/g, "$1 $2 $4" )
            }
            return '*';
          },
          multiEditSelectedOnPageStatus() {
            let ids = [];
            if (this.$refs.table) {
              this.$refs.table.rows.map((item) => {
                item.clinics.map(function (r) {
                  ids.push(r.link_id);
                });
              });
            }
            let resultCount = _.intersection(ids, this.multiEditSelectedIds).length;

            if (resultCount === 0) {
              return 'none';
            }
            if (resultCount === ids.length) {
              return 'all';
            }
            return 'part';
          },
          firstPageMultiSelectIndex () {
            if (this.multiEditSelectedOnPageStatus === 'none' || this.multiEditSelectedOnPageStatus === 'all'){
              return 0
            }
            let resIndex = 0;
            this.$refs.table.rows.every((item, index) => {
              item.clinics.forEach((r) => {
                if(this.multiEditSelectedIds.includes(r.link_id)){
                  resIndex = index;
                }
              });

              return resIndex === 0;
            });

            return resIndex;
          },
          lastPageMultiSelectIndex () {
            if (this.multiEditSelectedOnPageStatus === 'none' || this.multiEditSelectedOnPageStatus === 'all'){
              return 0
            }

            let resIndex = this.$refs.table.rows.length -1;
            _.clone( this.$refs.table.rows).reverse().every((item, index) => {
              item.clinics.forEach((r) => {
                if(this.multiEditSelectedIds.includes(r.link_id)){
                  resIndex = this.$refs.table.rows.length - 1 - index;
                }
              });

              return resIndex === this.$refs.table.rows.length -1;
            });

            return resIndex;
          },
            // searchTypeValue: function () {
            //     let foundType = Object.entries(this.clinicTypes).filter(val => {
            //         return val[1].value === this.$refs.table.filter.type;
            //     });
            //
            //     return foundType !== undefined && foundType.length > 0 ? foundType[0][1].text : '';
            // }
        }
    }
</script>

<style lang="scss" scoped>
header {
    display: flex;
    justify-content: space-between;
}
</style>
